import { useState, useEffect } from 'react';
import { fetchRule } from '../services/rule.service';
import { RuleEntity } from '../types/rule';

export function useRule() {
  const [rule, setRule] = useState<RuleEntity>();

  useEffect(() => {
    fetchRule().then(setRule).catch(console.error);
  }, []);

  return rule;
}
